const isOptionalContent = (pageClass) => pageClass.isOptional;

export default isOptionalContent;
